var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-denegada-main"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v("Acceso Restringido")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }